const EXPIRATION_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

export const isTokenExpired = (token: any): boolean => {
  const expirationDate = token?.exp * 1000;
  return expirationDate
    ? expirationDate - new Date().getTime() < EXPIRATION_DURATION
    : false;
};
